import Vue from 'vue';
//const queryString = require('query-string');
const toBool= {
    f: false,
    t: true,

};

function projectsCompare(a, b) {
  if (a.ets == b.ets) {
    return 0;
  }

  return a.ets < b.ets ? 1 : -1;
}

let availableSlicers = [
  {name: 'cloud', text: 'Cloud Slicer', weight: 2},
  {name: 'slicer3', text: 'Slicer 3', weight: 1},
  {name: 'mbot', text: 'Makerbot Slicer', weight: 0}
];
let slicerWeight = window.localStorage.getItem('slicerWeight');
if (slicerWeight) {
  try {
    slicerWeight = JSON.parse(slicerWeight);
  } catch (e) {
    console.log(e);
  }
}
let newSlicerWeight = {};
availableSlicers.forEach((slicer, index) => {
  if (!slicerWeight || !slicerWeight[slicer.name]) {
    newSlicerWeight[slicer.name] = slicer.weight;
  } else {
    availableSlicers[index].weight = slicerWeight[slicer.name];
  }
});
if (Object.keys(newSlicerWeight).length > 0) {
  window.localStorage.setItem('slicerWeight', JSON.stringify(Object.assign({}, slicerWeight, newSlicerWeight)));
}


/*
*
* <select class="upload-progress-gtype">
*   <option value="Simplify3D">Simplify3D</option>
*   <option value="Cura">Cura</option>
*   <option value="UltiGCode">UltiGCode</option>
*   <option value="Miracle-Grue">Miracle-Grue</option>
*   <option value="FlashForge">FlashForge</option></select>
*
* */
let gTupe = ["Simplify3D","Cura","UltiGCode","Miracle-Grue","FlashForge",]
/*
From Test deletein prod

"0";"deleted";""
"1";"uploaded";"orange"
"2";"keys generated";"orange"
"3";"moved to gserver";"orange"
"4";"secure";"blue"
"5";"ready to print";"green"
"6";"error";"red"
"7";"too big file";"red"
"8";"in_progress";"blue"
 */

export default  {
  state: {
    filesSelected: [],
    files: [],
    filesLastTimeUpdate: 0,
    filesType: {
      item: [
        {
          id: 0,
          name: 'not',
          color: 'gray'
        },
        {
          id: 1,
          name: 'stl',
          color: 'red'
        },
        {
          id: 2,
          name: 'gcode',
          color: 'blue'
        },
        {
          id: 3,
          name: 'cad',
          color: 'green'
        },
        {
          id: 4,
          name: 'all',
          color: 'green'
        },
        {
          id: 6,
          name: 'txt',
          color: 'gray'
        },
        {
          id: 7,
          name: 'BF',
          color: 'violet'
        },
        {
          id: 8,
          name: 'step',
          color: 'red'
        },
      ]
    },
    highlightedFiles: {},
    projects: [],
    projectsLoaded: false,
    filesLoaded: false,
    projectsLastTimeUpdate: 0,
    availableSlicers,
    gTupe,


  },
  mutations: {
    ADD_FILE (state, file) {
      Object.keys(file).map(function(key) {
        file[key] = (toBool[file[key]] !== undefined) ? toBool[file[key]] : file[key] ;
      });
      state.files.push(file)
    },
    REMOVE_FILE(state, fileIndex) {
      Vue.delete(state.files, fileIndex);
    },
    UPDATE_FILE(state, {file, fileIndex}) {
      Object.keys(file).map(function(key) {
        file[key] = (toBool[file[key]] !== undefined) ? toBool[file[key]] : file[key] ;
      });

      if(!file.active){
        file.datetime =  state.files[fileIndex].datetime
      }
      if(!state.files[fileIndex].show_select_printers){
        Vue.set(state.files, fileIndex, file);
      }

    },
    UPDATE_UPLOAD_FILE(state, {file, fileIndex}){


      if(file.uploadProgress){
        state.files[fileIndex].uploadProgress = file.uploadProgress
      }
      if(file.id){
        state.files[fileIndex].id = file.id
      }
      if(file.show_select_printers){
        state.files[fileIndex].show_select_printers = file.show_select_printers
      }
      if(file.project_id){
        state.files[fileIndex].project_id = file.project_id
      }

      //Vue.set(state.files, fileIndex, file);
    },
    TURN_OFF_UPLOAD_SELECTING_PRINTER_TYPE_STATE(state, fileIndex) {
      Vue.set(state.files, fileIndex, Object.assign({}, state.files[fileIndex], {show_select_printers: false}));
    },
    UPDATE_FILE_LAST_TIME(state, time){
      state.filesLastTimeUpdate = time
    },
    SET_FILES_SELECTED (state, fileId){
      state.filesSelected.push(fileId)
    },
    SET_FILES_SELECTED_ARRAY (state, filesId){
      state.filesSelected = filesId
    },
    REMOVE_FILES_SELECTED (state,  index){
      Vue.delete(state.filesSelected, index);
    },
    REMOVE_ALL_FILES_SELECTED (state){
      state.filesSelected = []
    },

    SET_FILE_HIGHLIGHT(state, {fileId, highlight}) {
      Vue.set(state.highlightedFiles, parseInt(fileId), highlight);
    },
    ADD_PROJECT (state, project) {
      Object.keys(project).map(function(key) {
        project[key] = toBool[project[key]] || project[key] ;
      });
      state.projects.push(project)
    },
    UPDATE_PROJECT(state, {project, projectIndex}) {
      Object.keys(project).map(function(key) {
        project[key] = toBool[project[key]] || project[key] ;
      });
      Vue.set(state.projects, projectIndex, project);
    },
    UPDATE_PROJECT_LAST_TIME(state, time){
      state.projectsLastTimeUpdate = time
    },
    REMOVE_PROJECT(state, projectIndex){
      Vue.delete(state.projects, projectIndex);
    },
    SET_PROJECTS_LOADED(state) {
      state.projectsLoaded = true;
    },
    SET_FILES_LOADED(state) {
      state.filesLoaded = true;
    },
    UPDATE_AVAILABLE_SLICER(state, {slicerIndex, slicer}) {
      Vue.set(state.availableSlicers, slicerIndex, slicer);
    }
  },
  actions: {
    async fetchFiles (context) {
      const {data} = await Vue.axios.post('a/myfiles/get_files',{
        prev_time: context.state.filesLastTimeUpdate
      });
      if(data.message && data.message != []){
        data.message.forEach(file => {
          let fileIndex = context.getters.getFileIndex(file.id)
          if(fileIndex > -1) context.commit('UPDATE_FILE', {file, fileIndex});
          else context.commit('ADD_FILE', file);
        })
      }
      context.commit('UPDATE_FILE_LAST_TIME', data.time);
      context.commit('SET_FILES_LOADED');
    },

    addUploadFile(context, file){
      context.commit('ADD_FILE', file);
      context.dispatch('highlightFile', file.id);
    },
    async updateUploadFile(context, file){

      let fileIndex = context.getters.getFileOnUiidIndex(file.uploadUiid);
      context.commit('UPDATE_UPLOAD_FILE', {file, fileIndex});
    },

    async saveUploadUpdate(context, file){

      let upload = {}
      upload['updates[' + file.id + '][gtype]'] =  'Simplify3D'
      upload['updates[' + file.id + '][zip]'] =  'false'
      upload['updates[' + file.id + '][ptype]'] =  file.ptype

      return new Promise((resolve, reject) => {
        Vue.axios.post('/upload/update', upload).then(({data}) => {
          resolve(data);
          if(data.result){
            let fileIndex = context.getters.getFileIndex(file.id);
            if(fileIndex >= 0) {
              context.commit('TURN_OFF_UPLOAD_SELECTING_PRINTER_TYPE_STATE', fileIndex);
            }
          }
        }).catch((e) => {
          reject(e);
        });
      });
    },

    async fetchFilesByParams (context, params){
      const {data} = await Vue.axios.post('a/myfiles/get_files', params);
      if(data.message && data.message != []){
        data.message.forEach(file => {
          let fileIndex = context.getters.getFileIndex(file.id)
          if(file.active == 'f'){
            context.commit('REMOVE_FILE', fileIndex)
          }else{
            if(fileIndex > -1) context.commit('UPDATE_FILE', {file, fileIndex});
            else context.commit('ADD_FILE', file);
          }
        })
      }
    },
    async deleteProject (context, projectId) {
      const {data} = await  Vue.axios.post('/ajax/delete_project', {id: projectId});
      if(data.deleted > 0){
        const projectIndex = context.getters.getProjectIndex(projectId);
        context.commit('REMOVE_PROJECT', projectIndex);

      }
    },

    async deleteFile (context, fileId) {
      await Vue.axios.post('/myfiles/delete',{id: fileId});
    },
    deleteFiles (context, files) {
       return Vue.axios.post('/myfiles/delete',files);
    },

    async undoFile (context, fileId) {
      await Vue.axios.post('/a/myfiles/undelete',{id: fileId});
    },


    async updateFile (context, file) {
      file.file_id = file.id
      file.name = file.filename
      await Vue.axios.post('a/myfiles/set_file_props', file);
    },

    getPrintFileInfo (context, fileId) {
      return Vue.axios.post('/a/print/get_fileinfo', {'file_id': fileId});
    },

    getFileInfo(context, fileId) {
      return Vue.axios.post('/a/myfiles/get_file_info', {'file_id': fileId});
    },

    getFileNotification(context, fileId) {
      return Vue.axios.post('/a/myfiles/get_file_notification', {'file_id': fileId});
    },

    getFileJobs(context, fileId) {
      return Vue.axios.get('/ajax/get_user_workflow_jobs', {
        params: {'file_id': fileId}
      });
    },

    getFileJobLog(context, jobId) {
      return Vue.axios.get('/ajax/get_workflow_job_log', {
        params: {'id': jobId}
      });
    },
    removeSelectFiles(context, fileId){
      let fileIndex = context.getters.getFilesSelectIndex(fileId)
      if(fileIndex > -1){
        context.commit('REMOVE_FILES_SELECTED', fileIndex)
      }
    },
    removeAllSelectFiles(context){
      context.commit('REMOVE_ALL_FILES_SELECTED')
    },
    setAllSelectFiles(context, isProject){
      let filter = [null]
      if(isProject){
        filter = [1,2]
      }
      let filesId = context.getters.getFilesId(filter)
      context.commit('SET_FILES_SELECTED_ARRAY', filesId)

    },
    addSelectFiles(context, fileId){
      context.commit('SET_FILES_SELECTED', fileId)
    },
    moveToProject(context, data){
      return Vue.axios.post('/a/myfiles/move_to_project', data);

    },
    copyToProject(context, data){
      return Vue.axios.post('/a/myfiles/copy_to_project', data);

    },
    getFileSharing(context, fileId) {
      return Vue.axios.post('/ajax/get_share_file_list', {'model_id': fileId, 'json': 1});
    },

    updateProject (context, project) {
      //
      return Vue.axios.post('/ajax/change_project_props', project);
    },
    async fetchProjects (context) {
      const {data} = await Vue.axios.post('a/myfiles/get_projects',{
        prev_time: context.state.projectsLastTimeUpdate
      });
      if(data.message && data.message !== []){
        data.message.projects_data.forEach(project => {
          const projectIndex = context.getters.getProjectIndex(project.id);
          if (projectIndex >= 0) {
            context.commit('UPDATE_PROJECT', {project, projectIndex});
          } else {
            context.commit('ADD_PROJECT', project);
          }
        });
        if (data.message.project_files && data.message.project_files.length) {
          data.message.project_files.forEach(file => {
            let needToHighlight = false;
            const fileIndex = context.getters.getFileIndex(file.id);
            if(fileIndex >= 0) {
              needToHighlight = file.project_id !== context.state.files[fileIndex].project_id;
              context.commit('UPDATE_FILE', {file, fileIndex});
            } else {
              needToHighlight = true;
              context.commit('ADD_FILE', file);
            }
            if (needToHighlight) {
              //Highlighting file
              context.dispatch('highlightFile', file.id);
            }
          });
        }
      }
      context.commit('UPDATE_PROJECT_LAST_TIME', data.time);
      context.commit('SET_PROJECTS_LOADED');
    },
    highlightFile(context, fileId) {
      context.commit('SET_FILE_HIGHLIGHT', {fileId, highlight: true});
      setTimeout(() => {
        context.commit('SET_FILE_HIGHLIGHT', {fileId, highlight: false});
      }, 20000);
    },
    updateSlicerWeight(context, slicerName) {
      const slicerIndex = context.state.availableSlicers.findIndex(slicer => slicer.name === slicerName);
      if (slicerIndex >= 0) {
        const slicer = Object.assign({}, context.state.availableSlicers[slicerIndex], {weight: Date.now()});
        context.commit('UPDATE_AVAILABLE_SLICER', {slicerIndex, slicer});
        let storedSlicerWeight = window.localStorage.getItem('slicerWeight');
        if (storedSlicerWeight) {
          storedSlicerWeight = JSON.parse(storedSlicerWeight);
          storedSlicerWeight[slicer.name] = slicer.weight;
          window.localStorage.setItem('slicerWeight', JSON.stringify(storedSlicerWeight));
        }
      }
    },
    getShareFileList(context, fileId) {
      return Vue.axios.post('/ajax/get_share_file_list?format=json', {'model_id': fileId});
    },
    getWorkgroupUsersForShare(context, {workgroupId, type, id}) {
      return Vue.axios.post('/user/get_workgroup_users_for_share', {
        'workgroup_id': workgroupId,
        'type': type,
        'id': id
      });
    },
    shareFile(context, {fileId, email, limit, checkUser}) {
      return Vue.axios.post('/ajax/share_file?format=json', {
        file_id: fileId,
        user_email: email,
        number_of_prints: limit,
        check_user: checkUser ? 1 : 0,
        not_existed: 1
      });
    },
    unshareFile(context, shareId) {
      return Vue.axios.post('/ajax/unshare_file?format=json', {share_id: shareId});
    },
    getShareProjectList(context, projectId) {
      return Vue.axios.post('/ajax/get_share_project_list?format=json', {'project_id': projectId});
    },
    shareProject(context, {projectId, email, checkUser}) {
      return Vue.axios.post('/ajax/share_project?format=json', {
        project_id: projectId,
        user_email: email,
        check_user: checkUser ? 1 : 0,
        not_existed: 1
      });
    },
    unshareProject(context, shareId) {
      return Vue.axios.post('/ajax/unshare_project?format=json', {share_id: shareId});
    },
    searchProjectsFiles(context, search) {
      return new Promise((resolve, reject) => {
        let excludeProjects = [];
        context.state.projects.map(project => {
          if (!context.getters.getFilesByProjectId(project.id).length) {
            excludeProjects.push(project.id);
          }
        });
        if (context.state.projects.length === excludeProjects.length) {
          resolve();
        } else {
          Vue.axios.post('/a/myfiles/project_search', {'search': search, 'exclude_projects': excludeProjects}).then(({data}) => {
            for (let i in data.message) {
              const file = data.message[i];
              const fileIndex = context.getters.getFileIndex(file.id);
              if(fileIndex >= 0) {
                context.commit('UPDATE_FILE', {file, fileIndex});
              } else {
                context.commit('ADD_FILE', file);
              }
            }
            resolve();
          }).catch(() => {
            reject();
          })
        }
      });
    },
    getImprintaGcodeInfo(context, {fileId, full}) {
      return Vue.axios.post('/a/imprinta/get_gcode_info', {file_id: fileId, full});
    },
  },
  getters: {
    getFileTypeInfo: state => id => {
      return state.filesType.item.find(type => type.id == id);
    },
    getFileIndex: state => id => {
      return state.files.findIndex(file => file.id == id);
    },
    getFileOnUiidIndex: state => uiid => {
      return state.files.findIndex(file => file.uploadUiid == uiid);
    },
    getGcodeInfo: state => id => {
      return state.files.findIndex(file => file.id == id);
    },
    getFiles: state => {
      return state.files.filter(file => file.project_id == null)
    },
    getFilesByProjectId: state => projectId => {
      return state.files.filter(file => file.project_id == projectId)
    },
    getFilesSelect: state => {
      return state.filesSelected
    },
    getFilesSelectFull: state => arr => {
      return state.files.filter(file =>  arr.indexOf(file.id) !== -1);
    },
    getFilesId:state => arr => {
      return state.files.filter(file =>  arr.indexOf(file.project_id) !== -1).map(file => { return file.id });
    },
    getFilesSelectIndex: state => id => {
      return state.filesSelected.findIndex(e=>{ return e == id})
    },
    isFilesSelect: state => {
      return state.filesSelected.length > 0
    },
    isFileHighlighted: state => fileId => {
      const highlighted = state.highlightedFiles[parseInt(fileId)];
      return highlighted !== undefined && highlighted;
    },
    getProjectIndex: state => projectId => {
      return state.projects.findIndex(project => project.id == projectId);
    },
    isProjectsLoaded: state => {
      return state.projectsLoaded
    },
    isFilesLoaded: state => {
      return state.filesLoaded
    },
    sortedProjects: state => {
      return state.projects.sort(projectsCompare);
    },
    gTupe: state => {
      return state.gTupe;
    },
    availableSlicersSorted: state => {
      return state.availableSlicers.sort((a, b) => {
        if (a.weight === b.weight) return 0;
        return a.weight < b.weight ? 1 : -1;
      });
    }
  }

}
